import { Model } from '@models/model';
import { Paginated } from '@models/paginated';

export class ListRatesProfile extends Paginated {
  data: Array<RatesProfile>;
}

export class RatesProfile extends Model {
  idRateProfile: number;
  name: string;
  defaultAmount: string;
  pricePerMessage: PricePerMessage;
}

export class PricePerMessage extends Model {
  gpPrice?: string;
  gsPrice?: string;
  siPrice?: string;
  tiPrice?: string;
  eePrice?: string;
  adPrice?: string;
}

export enum mTypeRateProfile {
  GP = 'GP',
  GS = 'GS',
  TI = 'TI',
  SI = 'SI',
  ADV = 'ADV',
  EE = 'EE',
  AD = 'AD'
}

export class RatesProfileNew extends Model {
  idRateProfile: number;
  name: string;
  defaultAmount: string;
  pricePerMessage: PricePerMessageNew[];
}

export class PricePerMessageNew extends Model {
  type: string;
  idDestinationNation: string;
  cost: string;
  idRateProfile: number;
}
